import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AuthguardService {

  constructor() { }
  IsLoggedIn():boolean {
    return !!localStorage.getItem('token'); 
   }
}
